import {
    post
} from '../configApi'

export async function insertBanner(body) {
    return await post(`/banner/manage/insert`, body)
}